import brandPortalOrders from "@faire/web-api/routes/brand-portal/orders";
import brandPortalOrdersbrandOrderTokenEdit from "@faire/web-api/routes/brand-portal/orders/brandOrderToken/edit";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
export var EditOrderInformationIA = function EditOrderInformationIA(_ref) {
  var _context$brandOrder, _context$brandOrder$b;
  var context = _ref.context;
  var brandOrderToken = (_context$brandOrder = context.brandOrder) === null || _context$brandOrder === void 0 ? void 0 : (_context$brandOrder$b = _context$brandOrder.brand_order) === null || _context$brandOrder$b === void 0 ? void 0 : _context$brandOrder$b.token;
  if (brandOrderToken) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "ea0MKp",
      defaultMessage: [{
        "type": 0,
        "value": "Je kunt de bestelgevens bewerken door eerst naar de "
      }, {
        "children": [{
          "type": 0,
          "value": "bestellingspagina"
        }],
        "type": 8,
        "value": "OrderDetailsLinkFormatting"
      }, {
        "type": 0,
        "value": " te gaan. Klik vervolgens op de link "
      }, {
        "children": [{
          "type": 0,
          "value": "Bewerken"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " om wijzigingen aan te brengen in verzendgegevens, promoties of producten."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return EditOrderLinkFormatting(chunks, brandOrderToken);
        },
        OrderDetailsLinkFormatting: function OrderDetailsLinkFormatting(chunks) {
          return OrderLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "V3/NqV",
      defaultMessage: [{
        "type": 0,
        "value": "Je kunt het verzendadres of de verzenddatum bewerken door op het penpictogram naast de betreffende secties te klikken. Nadat je je bewerkingen hebt uitgevoerd, klik je op "
      }, {
        "children": [{
          "type": 0,
          "value": "Bijwerken"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " om ze op te slaan."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "4Xj61v",
      defaultMessage: [{
        "type": 0,
        "value": "Je kunt producthoeveelheden bijwerken door de velden "
      }, {
        "children": [{
          "type": 0,
          "value": "Aantal"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " te bewerken. Je past ook een promotie toe of verwijdert deze uit de bestelling."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "aQBXiZ",
      defaultMessage: [{
        "type": 0,
        "value": "Wanneer je wijzigingen aanbrengt, heb je de optie om een bericht achter te laten voor de retailer, wat we erg aanbevelen voor een positieve klantervaring. De retailer ontvangt een e-mail met de wijzigingen."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  } else {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "XGPsSb",
      defaultMessage: [{
        "type": 0,
        "value": "Om de bestellingsgegevens voor een nieuwe of niet-verwerkte bestelling te bewerken, ga je eerst naar je "
      }, {
        "children": [{
          "type": 0,
          "value": "Bestellingen"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " en ga je naar de pagina "
      }, {
        "children": [{
          "type": 0,
          "value": "Bestellingsgegevens"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " voor de bestelling die je wilt wijzigen. Klik vervolgens op de link "
      }, {
        "children": [{
          "type": 0,
          "value": "Bewerken"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " om wijzigingen aan te brengen in verzendgegevens, promoties of producten."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        },
        LinkFormatting: function LinkFormatting(chunks) {
          return OrderLinkFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "1Bp3jy",
      defaultMessage: [{
        "type": 0,
        "value": "Je kunt het verzendadres of de verzenddatum bewerken door op het penpictogram naast de betreffende secties te klikken. Nadat je je bewerkingen hebt uitgevoerd, klik je op "
      }, {
        "children": [{
          "type": 0,
          "value": "Bijwerken"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " om ze op te slaan."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "AXd4P9",
      defaultMessage: [{
        "type": 0,
        "value": "Je kunt producthoeveelheden bijwerken door de velden "
      }, {
        "children": [{
          "type": 0,
          "value": "Aantal"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " te bewerken. Je past ook een promotie toe of verwijdert deze uit de bestelling."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "yD2687",
      defaultMessage: [{
        "type": 0,
        "value": "Wanneer je wijzigingen aanbrengt, heb je de optie om een bericht achter te laten voor de retailer, wat we erg aanbevelen voor een positieve klantervaring. De retailer ontvangt een e-mail met de wijzigingen."
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })));
  }
};
var EditOrderLinkFormatting = function EditOrderLinkFormatting(chunks, brandOrderToken) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrdersbrandOrderTokenEdit(brandOrderToken),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var OrderLinkFormatting = function OrderLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalOrders(),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};